import { useFormState } from "../Hooks/useFormState";
import { useFormEditState } from "../Hooks/useFormEditState";
import { Badge } from "@/components/catalyst/badge";
import { useFormikContext } from "formik";

export function FormationErrorBadge() {
  const { errorCount } = useFormState();
  const { isEditing } = useFormEditState();
  const { isValid, submitCount } = useFormikContext();
  const isError = !(isValid || !isEditing);

  if (!isError) {
    return null;
  }

  if (errorCount === 0 || submitCount === 0) {
    return null;
  }

  return (
    <Badge color="red" className="h-fit shrink-0 whitespace-nowrap">
      {`${errorCount} ${errorCount === 1 ? "Error" : "Errors"}`}
    </Badge>
  );
}
